/* src/app/components/header/header.component.css */
@media (max-width: 1400px) {
  .ps-nav {
    padding-left: 10px !important;
    padding-right: 8px !important;
  }
}
.fusion-brand {
  display: flex;
  align-items: center;
  padding: 0 16px 0 0;
  width: 248px;
  flex-shrink: 0;
  text-decoration: none;
  cursor: pointer;
  border-right: 1px solid rgba(255, 255, 255, 0.12);
  margin-right: 16px !important;
}
@media (max-width: 1400px) {
  .brand-logo-wrap img {
    height: 40px !important;
  }
}
@media (max-width: 400px) {
  .brand-title {
    display: none;
  }
  .fusion-brand {
    width: auto;
    min-width: 0;
  }
}
.mobile-toggler-btn {
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  padding: 6px 10px !important;
  background: rgba(255, 255, 255, 0.05) !important;
  transition: background 0.15s;
  line-height: 1;
}
.mobile-nav-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.50);
  z-index: 1040;
  touch-action: none;
  overscroll-behavior: none;
}
@keyframes drawerSlideIn {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
}
.mobile-nav-drawer {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 280px;
  background: var(--navy-900);
  z-index: 1050;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: drawerSlideIn 300ms ease forwards;
}
.mobile-nav-drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 74px;
  padding: 0 16px;
  flex-shrink: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.10);
}
.mobile-drawer-brand {
  display: flex;
  align-items: center;
  text-decoration: none;
  cursor: pointer;
  overflow: hidden;
}
.mobile-drawer-close {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: var(--radius-xs);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background 0.14s;
}
.mobile-drawer-close:hover {
  background: rgba(255, 255, 255, 0.10);
}
.mobile-nav-body {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}
.mobile-nav-link {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 15px 20px;
  color: rgba(255, 255, 255, 0.82) !important;
  font-size: 1em;
  font-weight: 500;
  text-decoration: none;
  background: transparent;
  border: none;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  cursor: pointer;
  transition: background 0.14s, color 0.14s;
  text-align: left;
}
.mobile-nav-submenu {
  background: rgba(0, 0, 0, 0.18);
}
.mobile-nav-footer {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px 12px 14px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(0, 0, 0, 0.15);
}
.mobile-lang-group {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  margin-bottom: 2px;
}
.mobile-footer-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: var(--radius-sm);
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  padding: 10px 14px;
  font-size: 0.9em;
  transition: background 0.13s, color 0.13s;
}
.mobile-logout-btn {
  color: rgba(255, 120, 120, 0.85);
  border-color: rgba(255, 100, 100, 0.2);
}
.mobile-footer-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.sidenav {
  height: calc(100vh - 74px - 16px);
  width: 244px;
  position: fixed;
  padding-top: 8px;
  top: 82px;
  left: 8px;
  background-color: var(--fg-on-navy);
  overflow-x: hidden;
  z-index: 1000;
  border-radius: 12px;
  box-shadow: var(--shadow-md);
}
.sidenav a {
  padding: 6px 8px 6px 16px;
  text-decoration: none;
  font-size: 1.3em;
  color: var(--fg-2);
  display: block;
}
.sidenav a.active-links {
  background-color: var(--navy-600);
  color: var(--fg-on-navy);
  border-radius: var(--radius-md);
  margin: 2px 8px;
  padding-left: 12px !important;
}
.sidenav a:hover {
  background-color: rgba(0, 0, 0, 0.07);
}
.sidenav a.active-links:hover {
  background-color: var(--navy-600);
  color: var(--fg-on-navy);
}
@media screen and (max-height: 450px) {
  .sidenav {
    padding-top: 15px;
  }
  .sidenav a {
    font-size: 18px;
  }
}
.mobile-notif-btn {
  position: relative;
  padding: 6px 10px;
  margin-right: 2px;
  line-height: 1;
  display: inline-flex !important;
  align-items: center;
  gap: 3px;
}
.mobile-notif-btn .notification_num {
  position: static;
  font-size: 0.72rem;
  padding: 1px 5px;
  border-radius: var(--radius-md);
  line-height: 1.5;
  vertical-align: middle;
}
.sidenav-float-tab {
  position: fixed;
  left: 0;
  top: 100px;
  z-index: 999;
  width: 36px;
  height: 48px;
  background: var(--navy-600);
  border-radius: 0 8px 8px 0;
  border: none;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.20);
  opacity: 0.38;
  transition: width 0.15s ease, opacity 0.2s ease;
}
.sidenav-float-tab:hover {
  width: 40px;
  opacity: 1;
}
.mobile-sidenav-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.50);
  z-index: 1040;
  touch-action: none;
  overscroll-behavior: none;
}
.mobile-sidenav-drawer {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 260px;
  background: var(--fg-on-navy);
  z-index: 1050;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: drawerSlideIn 300ms ease forwards;
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.15);
}
.mobile-sidenav-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 74px;
  padding: 0 16px;
  flex-shrink: 0;
  border-bottom: 1px solid var(--border);
  background: var(--navy-600);
}
.mobile-sidenav-title {
  color: var(--fg-on-navy);
  font-size: 1.05em;
  font-weight: 600;
  letter-spacing: 0.05em;
}
.mobile-sidenav-body {
  flex: 1;
  overflow-y: auto;
  padding: 8px 0;
}
.mobile-sidenav-body a {
  display: block;
  padding: 6px 8px 6px 16px;
  color: var(--fg-2);
  text-decoration: none;
  font-size: 1.3em;
  transition: background 0.12s;
}
.mobile-sidenav-body a:hover {
  background-color: rgba(0, 0, 0, 0.07);
}
.mobile-sidenav-body a.active-links {
  background-color: var(--navy-600);
  color: var(--fg-on-navy);
  border-radius: var(--radius-md);
  margin: 2px 8px;
  padding-left: 12px !important;
}
.mobile-sidenav-body a.active-links:hover {
  background-color: var(--navy-600);
  color: var(--fg-on-navy);
}
/*# sourceMappingURL=header.component.css.map */
